angular
    .module('festzelt-os.guestlists')
    .factory('goToSeatplan', [
        '$state',
        goToSeatplan
    ]);

function goToSeatplan($state) {
    return {
        key: 'go-to-seatplan',
        title: 'Go to seatplan',
        level: 'highlight',
        icon: 'sitemap',
        storeAccessor: (store) => {
            return !!_.get(store, 'state.vm.guestlist.seatplan_id', false);
        },
        action: function (action, store) {
            return $state.go('app.guestlists.rsvps.seats', {guestlist: store.state.vm.guestlist.id});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/go-to-seatplan.js